import React from 'react'
import { Link } from 'react-router-dom'
// import bg3 from '../../assets/images/background/bg-3.png'
// import badge1 from '../../assets/images/resource/badge-1.png'
// import since from '../../assets/images/resource/since-1990.png'
import img1 from '../../assets/images/resource/image-1.jpg'
import img2 from '../../assets/images/resource/image-2.jpg'

function Story() {
    return (
        <>
            <section className="story-section">
                {/* <div className="left-bg">
                    <img src={bg3} alt="" title="" />
                </div> */}
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="text-col col-xl-5 col-lg-5 col-md-12 col-sm-12">
                            <div className="inner wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="title-box centered">
                                    <div className="subtitle">
                                        <span> Our story </span>
                                    </div>
                                    <div className="pattern-image">
                                        <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                                    </div>
                                    <h2>Every Flavour Tells a Story</h2>
                                    <div className="text">For over three decades, Chez François has been Canmore’s cozy spot for all-day breakfast and mountain-view brunch. From our famous Eggs Benedict with house-made hollandaise to locally loved classics, every plate is cooked with care since 1990.</div>
                                </div>
                                <div className="booking-info">
                                    {/* <div className="bk-title">Book Online</div> */}
                                    <div className="link-box">
                                        <Link to="https://www.opentable.ca/restref/client/?rid=1411912&restref=1411912&lang=en-CA&color=1&r3uid=cfe&dark=false&partysize=6&datetime=2025-08-21T22%3A30&ot_source=Restaurant%20website&corrid=497d104c-c015-4655-bcf6-4abdfe7c9bc0" className="theme-btn btn-style-two clearfix">
                                            <span className="btn-wrap">
                                                <span className="text-one">Book a table</span>
                                                <span className="text-two">Book a table</span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="image-col col-xl-7 col-lg-7 col-md-12 col-sm-12">
                            <div className="inner wow fadeInRight" data-wow-duration="1500ms" data-wow-delay="0ms">
                                {/* <div className="round-stamp"><img src={badge1} alt="" /></div> */}
                                <div className="images parallax-scene-1">
                                    {/* <div className="image" data-depth="0.15"><img src={img1} alt="" /></div>
                                    <div className="image" data-depth="0.30"><img src={img2} alt="" /></div> */}
                                    <div className="image" data-depth="0.15"><img src={img2} alt="" /></div>
                                    <div className="image" data-depth="0.30"><img src={img1} alt="" /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Story